import {
  selectManageAccessDraft,
  selectManageAccessExternalUsers,
  selectManageAccessInternalUsers,
} from '@/store/selectors/manageAccess';
import {
  setManageAccessDraftField,
  setManageAccessHasPendingExternalManualEntries,
} from '@/store/slices/manageAccess/manageAccessSlice';
import { useExternalInvitationsAdapter } from '@/hooks/shared/useExternalInvitationsAdapter';

export function useStepManageAccessExternal() {
  return useExternalInvitationsAdapter({
    selectDraft: selectManageAccessDraft,
    selectInternalUsers: selectManageAccessInternalUsers,
    selectExternalUsers: selectManageAccessExternalUsers,
    dispatchSetExternalParticipantIds: (dispatch, value) =>
      dispatch(setManageAccessDraftField({ key: 'externalParticipantIds', value })),
    dispatchSetNewExternalUsers: (dispatch, value) =>
      dispatch(setManageAccessDraftField({ key: 'newExternalUsers', value })),
    dispatchSetHasPendingEntries: (dispatch, value) =>
      dispatch(setManageAccessHasPendingExternalManualEntries(value)),
  });
}
